var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "modal",
    {
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.name))]),
        _c("div", {
          staticClass: "content",
          domProps: { innerHTML: _vm._s(_vm.content) },
        }),
        _vm.showMoreAnnouncementButton && (true || _vm.unread)
          ? _c(
              "a",
              {
                staticClass: "see-more btn btn-primary",
                attrs: { href: "/announcements" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("announcement.see_more", { unread: _vm.unread })
                  )
                ),
              ]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }